export const WHATSAPP_NUMBER = "919346042323";
export const SUPPORT_EMAIL = "naathicharami23@gmail.com";

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/naathi_charami?igsh=YTU3YTF1aTk4eGE0",
  facebook: "https://www.facebook.com/share/1BBj9BeJVs/?mibextid=wwXIfr",
  youtube: "https://youtube.com/@naathicharamigifts?si=5U73BAy8sVdkx9aX",
  whatsapp: `https://wa.me/${WHATSAPP_NUMBER}`,
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_aa65a91d-340e-4aa7-962a-749b26bc8c32/artifacts/x3jdsckc_WhatsApp%20Image%202026-06-24%20at%2009.33.17.jpeg";
export const FOUNDER_URL = "https://customer-assets.emergentagent.com/job_aa65a91d-340e-4aa7-962a-749b26bc8c32/artifacts/u8tj1ywe_WhatsApp%20Image%202026-06-24%20at%2009.40.18.jpeg";

// Metadata for admin tile slugs that are NOT part of the shop CATEGORIES array
// (used by AdminDashboard to render friendly names in the tile settings grid)
export const TILE_META_EXTRAS = {
  founder: {
    name: "Founder Photo — Monalika Reddy",
    image: FOUNDER_URL,
    description: "Shown on the About page and the homepage 'Why Choose' section.",
  },
  "about-side": {
    name: "About Page — Behind the Scenes",
    image: "https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=1600&q=80",
    description: "Large landscape banner shown below the founder story on /about.",
  },
  "hero-bg": {
    name: "Homepage — Hero Background",
    image: "",  // empty by default → uses pink gradient
    description: "Optional background image behind the hero. Leave empty to keep the pink gradient.",
  },
};

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const CATEGORIES = [
  {
    slug: "her",
    name: "Gifts for Her",
    image: "https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=1200&q=80",
    description: "Curated luxuries for the woman who deserves every thoughtful detail.",
  },
  {
    slug: "him",
    name: "Gifts for Him",
    image: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1200&q=80",
    description: "Refined essentials for the modern gentleman.",
  },
  {
    slug: "kids",
    name: "Gifts for Kids",
    image: "https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=1200&q=80",
    description: "Joyful, wholesome hampers that spark wonder.",
  },
  {
    slug: "babies",
    name: "Gifts for Babies",
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=1200&q=80",
    description: "Sweet, soft, snuggly hampers for the tiniest of celebrations.",
  },
  {
    slug: "baskets",
    name: "Baskets Collection",
    image: "https://images.unsplash.com/photo-1576020799627-aeac74d58064?w=1200&q=80",
    description: "Grand handcrafted baskets — festive, abundant, unforgettable.",
  },
  {
    slug: "diwali",
    name: "Diwali Hampers",
    image: "https://images.unsplash.com/photo-1699801676350-4182399f7cdd?w=1200&q=80",
    description: "Festive Diwali hampers — sweets, diyas, dry fruits & handcrafted treasures for a luminous celebration.",
  },
];

// Diwali reminder — used on Home + product pages
export const DIWALI_INFO = {
  date: "8 November 2026",
  greeting: "Diwali is on 8 November 2026",
  bulkMessage: (name) => `Hi Naathi Charami! 🪔 I'm interested in placing a bulk order for "${name}". Please share the bulk pricing and details.`,
};

export const HAMPER_CATALOGUES = [
  { name: "Baby Shower Hampers", image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=900&q=80" },
  { name: "Birthday Hampers", image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=900&q=80" },
  { name: "Engagement Hampers", image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=900&q=80" },
  { name: "Wedding Hampers", image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=900&q=80" },
  { name: "Chief Guest Hampers", image: "https://images.unsplash.com/photo-1549049950-48d5887197a0?w=900&q=80" },
  { name: "Get Well Soon Hampers", image: "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=900&q=80" },
  { name: "Bridal Shower Hampers", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=900&q=80" },
];

export const BULK_CATALOGUES = [
  { name: "Baby Shower Hampers", image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=900&q=80" },
  { name: "Event Return Gifts", image: "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?w=900&q=80" },
  { name: "Birthday Hampers", image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=900&q=80" },
  { name: "Engagement Hampers", image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=900&q=80" },
  { name: "Wedding Hampers", image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=900&q=80" },
  { name: "Corporate Hampers", image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80" },
  { name: "Bridesmaids Hampers", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=900&q=80" },
];

export const GALLERY = [
  { title: "Wedding Hampers", image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=900&q=80" },
  { title: "Corporate Gifting", image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80" },
  { title: "Birthday Hampers", image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=900&q=80" },
  { title: "Return Gifts", image: "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?w=900&q=80" },
  { title: "Wedding Favours", image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=900&q=80" },
  { title: "Event Favours", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=900&q=80" },
  { title: "Festive Hampers", image: "https://images.unsplash.com/photo-1620331311520-246422fd82f9?w=900&q=80" },
  { title: "Custom Hampers", image: "https://images.unsplash.com/photo-1576020799627-aeac74d58064?w=900&q=80" },
];

export const WHY_CHOOSE = [
  { icon: "Sparkles", title: "Customized Gifting Solutions", desc: "Every hamper, personalised to occasion and recipient." },
  { icon: "Award", title: "Premium Quality Products", desc: "Curated artisans, premium brands, exquisite finishing." },
  { icon: "Package", title: "Bulk Order Support", desc: "Weddings, corporate, events — handled at any scale." },
  { icon: "PenTool", title: "Personalized Notes", desc: "Hand-written messages with every gift, on request." },
  { icon: "MapPin", title: "Hyderabad Delivery", desc: "Fast, careful, personally-overseen city-wide delivery." },
];
